export default __webpack_public_path__ + "static/media/100.8db1efff.jpg";